import { Row, Col, Typography, Image } from 'antd'
import { t } from 'i18next'
import { useBusinessCardOrderDetailMutation } from '@app/store/reducers/salaryCards/businessCardOrder.api'

const { Text } = Typography

const RowItem = ({
  label,
  value,
  red = false,
  bottomBorder = true,
}: {
  label: string
  value: string | number | React.ReactNode
  red?: boolean
  bottomBorder?: boolean
}) => (
  <div className={`${bottomBorder ? 'rowBorderBottom' : ''} flexRow`} style={{ position: 'relative' }}>
    <Text className="custom-text-color">{label}: </Text>
    <Text style={red ? { color: 'red' } : undefined}>{value}</Text>
  </div>
)

const OrderDetailModalHeader = () => {
  const [_, { data: detailInformationList }] =
    useBusinessCardOrderDetailMutation({
      fixedCacheKey: 'businessCardOrderDetail',
    })

  const {
    cardCurrency,
    cardSystem,
    orderType,
    orderDeliveryType,
    accountBranchName,
    transferredBranchName,
    note,
    trustedPerson,
    cardAccount,
    cardDuration,
    cardName,
    cardImageUrl,
    commission
  } = detailInformationList || {}
  
  const { fullName, pin, phone, expiryDate } = trustedPerson || {}

  return (
    <Row
      justify="space-evenly"
      gutter={[32, 0]}
      style={{ marginBottom: '20px' }}
    >
      <Col md={8}>
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.cardCurrency')}
          value={cardCurrency}
        />
        <RowItem
          label={t('businessCardOrders.labels.paySytsem')}
          value={cardSystem}
        />
        <RowItem
          label={t('businessCardOrders.labels.cardName')}
          value={<><span style={{ marginRight: 65 }}>{cardName}</span> <div
                          style={{
                            borderRadius: '4px',
                            padding: '4px',
                            backgroundColor: '#fff',
                            border: '1px solid #D9E3EC',
                            cursor: 'pointer',
                            position: 'absolute',
                            top: -9,
                            right: 0,
                          }}
                        >
                          <Image width={49} height={30} preview={false} src={cardImageUrl} />
                        </div></>}
        />
        <RowItem
          label={t('businessCardOrders.labels.cardDuration')}
          value={`${cardDuration} ${t('businessCardOrders.labels.year')}`}
        />
        <RowItem
          label={t('businessCardOrders.labels.issueFree')}
          value={`${Number(commission?.issueFee).toFixed(2)} AZN`}
        />
        <RowItem
          bottomBorder={false}
          label={t('orders.salaryCardOrder.inputLabels.note')}
          value={note}
        />
      </Col>

      <Col md={8}>
        <RowItem
          label={t('businessCardOrders.labels.cardAccount')}
          value={cardAccount}
        />
        <RowItem
          label={t('businessCardOrders.labels.accountBranch')}
          value={accountBranchName}
        />
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.BranchTransferred')}
          value={transferredBranchName}
        />
        <RowItem
          label={t('orders.salaryCardOrder.tableTitles.receivingTransfer')}
          value={t(`orders.salaryCardOrder.constants.${orderDeliveryType}`)}
        />
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.orderTypes')}
          value={t(`orders.salaryCardOrder.constants.${orderType}`)}
        />
        <RowItem
          bottomBorder={false}
          label={t('businessCardOrders.labels.totalCommission')}
          value={`${Number(commission?.preparationFee).toFixed(2)} AZN`}
        />
      </Col>

      <Col md={8}>
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.fullName')}
          value={fullName}
        />
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.pin')}
          value={pin}
        />
        <RowItem
          label={t('orders.salaryCardOrder.tableTitles.phoneNumber')}
          value={phone}
        />
        <RowItem
          label={t('orders.salaryCardOrder.tableTitles.expiryDate')}
          value={expiryDate}
        />
        <RowItem
          bottomBorder={false}
          label={t('businessCardOrders.labels.totalPay')}
          value={`${Number(commission?.totalFee).toFixed(2)} AZN`}
        />
      </Col>
    </Row>
  )
}

export default OrderDetailModalHeader
